import React, { Component } from "react";
import { Dialog } from "@material-ui/core";
import { DialogH1, Dialogp, DesignedButtonD } from "./UploadCompleteStyle";
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import i18n from "../../i18n";
import './UploadComplete.scss';
import { getIsExpiredDate } from "@/utils/DateHelper";
import { POINT_UI_EXPIRED_DATE } from "@/utils/Global";
const styles = {
  maxWidthXs : {
    maxWidth : "520px"
  }
};

// const content = {
//   'DifferentPassword': {
//     type: 'DifferentPassword',
//     dialogBodyText1:"sdfsdf"
//   },
//   'NoEmail': {
//     type: 'NoEmail',
//     dialogBodyText1:"sdfsdf"
//   },
//   'removeTemplate' : {
//     DesignedButtonText : "확인"
//   },
// }
class UploadCompleted extends Component {
  render() {
    const { closeUploadCompletedDialog,
      closeBtn,
      open,
       DesignedButtonText ,
       dialogBodyText1,
       dialogBodyText2,
       dialogHeadText,
       noButton,
       left,
       width,
      //  dialogType,
      showGallery
      } = this.props;
    // const what = content[dialogType]
    return (
      <>
        <Dialog fullWidth = {this.props.fullWidth} className={classNames(this.props.classes.paperWidthXs)} maxWidth ={"sm"} open={open} disableBackdropClick onClose={closeBtn}>
          <div className="closeBtn" onClick={closeBtn} style ={this.props.hide ? {display : "none"} : {display : "block"}}>
            <div className="closeBar1" />
            <div className="closeBar2" />
          </div>
          <DialogH1>{dialogHeadText}</DialogH1>
          <Dialogp>
            <div>{dialogBodyText1}</div>
            <div>{dialogBodyText2}</div>
          </Dialogp>
          <div style={{ padding: "1.5rem 0 2rem 0" }}>
            {noButton 
              ? null 
              : <DesignedButtonD
                  value={this.props.value}
                  color={"darkGray"}
                  text={DesignedButtonText}
                  onClick={closeUploadCompletedDialog("GoToMypage")}
                  left={left}
                  width = {width}
                />
            }
          </div>
          {
           getIsExpiredDate(POINT_UI_EXPIRED_DATE) && showGallery &&
            <div className="gallery-review-container">
              <label>
                <input checked={this.props.isCheckGalleryUpload} type="checkbox" onChange={this.props.clickShowGallery}></input>
                {i18n.t("web.ask.gallery.upload")}
              </label>
            </div>
          }
        </Dialog>
      </>
    );
  }
}

export default withStyles(styles)(UploadCompleted);
